import React from "react";
import MakroAlert, { MakroAlertType } from "../common/alert";
import style from "./code.module.css";
import { CodeCheckResult } from "./code";
var CodeInvalid = function CodeInvalid(_ref) {
    var setCheckResult = _ref.setCheckResult;
    return /*#__PURE__*/ React.createElement("div", {
        className: "content-text mt-4"
    }, /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        title: "Code ung\xFCltig",
        text: "Der angegebene Code ist ung\xFCltig. Bitte versuchen Sie es erneut oder wenden Sie sich an aboservice@makroskop.eu."
    }), /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return setCheckResult(CodeCheckResult.NONE);
        },
        className: style.buttonGray
    }, "Anderen Code pr\xFCfen"));
};
export default CodeInvalid;
